import { Component } from "../Component";
import { DOM } from "../../utils/DOM";
import { Map } from "./Map";
import { Infra3DDataProvider as Infra3DDataProvider_v2 } from "../../api/Infra3DDataProvider_v2";
import { Infra3DDataProvider as Infra3DDataProvider_v3 } from "../../api/Infra3DDataProvider_v3";
import { Infra3DDataProviderBase } from "../../api/Infra3DDataProviderBase";
/**
 * @class MapComponent
 * @classdesc Component showing a map for navigation.
 */
export class MapComponent extends Component {
    constructor(name, container, navigator, dom) {
        super(name, container, navigator);
        this._dom = dom ? dom : new DOM();
    }
    get map() {
        return this._map;
    }
    _activate() {
        this._configurationSubscription = this._configuration$.subscribe((configuration) => {
            if (typeof configuration.container === "string") {
                this._mapContainer = this._dom.document.getElementById(configuration.container);
                if (!this._mapContainer) {
                    throw new Error(`Container "${configuration.container}" not found.`);
                }
            }
            else if (configuration.container instanceof HTMLElement) {
                this._mapContainer = configuration.container;
            }
            else {
                throw new Error(`Invalid type: "container" must be a String or HTMLElement.`);
            }
            if (this._navigator.api.data instanceof Infra3DDataProvider_v2 ||
                this._navigator.api.data instanceof Infra3DDataProvider_v3) {
                if (this._navigator.api.data.getCollection() == "")
                    return;
            }
            if (this._map)
                this._map.deactivate();
            this._map = new Map(this._container, this._mapContainer, this._navigator, configuration);
        });
    }
    _deactivate() {
        this._configurationSubscription.unsubscribe();
        this._map.deactivate();
    }
    _getDefaultConfiguration() {
        let config;
        if (this._navigator.api.data instanceof Infra3DDataProviderBase) {
            config = {
                baselayers: [
                    {
                        type: "OSM",
                        name: "OpenStreetMap",
                        icon: {
                            wellknown: "osm",
                        },
                    },
                ],
                campaignstylemode: "background",
                tooltip: [],
                // overviewlayers: [
                //     {
                //         type: "routes",
                //         zoomrange: [14, 19],
                //     },
                //     {
                //         type: "routes_simplified",
                //         zoomrange: [7, 14],
                //     },
                //     {
                //         type: "routes_outline",
                //         zoomrange: [0, 7],
                //     },
                // ],
                startupzoom: 15,
                overviewsegmentedonly: false,
                locale: {
                    zoomin: "Zoom In",
                    zoomout: "Zoom Out",
                    basemaps: "Basemaps",
                    legend: "Network layer legend",
                },
                hidecontrols: true,
            };
        }
        return config;
    }
    resize() {
        if (this._map) {
            this._map.resize();
        }
    }
    configure(newConf) {
        const conf = this._getDefaultConfiguration();
        if (this.map) {
            if (this.map.olmap)
                conf.startupzoom = this.map.olmap.getView().getZoom();
        }
        for (const key in newConf) {
            if (Object.prototype.hasOwnProperty.call(newConf, key)) {
                conf[key] = newConf[key];
            }
        }
        this._configurationSubject$.next(conf);
    }
}
/** @inheritdoc */
MapComponent.componentName = "map";
//# sourceMappingURL=MapComponent.js.map